function horizontalLoop(items, config) {
  let timeline;
  items = gsap.utils.toArray(items);
  config = config || {};
  gsap.context(() => { // use a context so that if this is called from within another context or a gsap.matchMedia(), we can perform proper cleanup like the "resize" event handler on the window
    let onChange = config.onChange,
      lastIndex = 0,
      tl = gsap.timeline({repeat: config.repeat, onUpdate: onChange && function() {
          let i = tl.closestIndex();
          if (lastIndex !== i) {
            lastIndex = i;
            onChange(items[i], i);
          }
        }, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
      length = items.length,
      startX = items[0].offsetLeft,
      times = [],
      widths = [],
      spaceBefore = [],
      xPercents = [],
      curIndex = 0,
      indexIsDirty = false,
      center = config.center,
      pixelsPerSecond = (config.speed || 1) * 100,
      snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
      timeOffset = 0,
      container = center === true ? items[0].parentNode : gsap.utils.toArray(center)[0] || items[0].parentNode,
      totalWidth,
      getTotalWidth = () => items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + spaceBefore[0] + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0),
      populateWidths = () => {
        let b1 = container.getBoundingClientRect(), b2;
        items.forEach((el, i) => {
          widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
          xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / widths[i] * 100 + gsap.getProperty(el, "xPercent"));
          b2 = el.getBoundingClientRect();
          spaceBefore[i] = b2.left - (i ? b1.right : b1.left);
          b1 = b2;
        });
        gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
          xPercent: i => xPercents[i]
        });
        totalWidth = getTotalWidth();
      },
      timeWrap,
      populateOffsets = () => {
        timeOffset = center ? tl.duration() * (container.offsetWidth / 2) / totalWidth : 0;
        center && times.forEach((t, i) => {
          times[i] = timeWrap(tl.labels["label" + i] + tl.duration() * widths[i] / 2 / totalWidth - timeOffset);
        });
      },
      getClosest = (values, value, wrap) => {
        let i = values.length,
          closest = 1e10,
          index = 0, d;
        while (i--) {
          d = Math.abs(values[i] - value);
          if (d > wrap / 2) {
            d = wrap - d;
          }
          if (d < closest) {
            closest = d;
            index = i;
          }
        }
        return index;
      },
      populateTimeline = () => {
        let i, item, curX, distanceToStart, distanceToLoop;
        tl.clear();
        for (i = 0; i < length; i++) {
          item = items[i];
          curX = xPercents[i] / 100 * widths[i];
          distanceToStart = item.offsetLeft + curX - startX + spaceBefore[0];
          distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
          tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
            .fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
            .add("label" + i, distanceToStart / pixelsPerSecond);
          times[i] = distanceToStart / pixelsPerSecond;
        }
        timeWrap = gsap.utils.wrap(0, tl.duration());
      },
      refresh = (deep) => {
        let progress = tl.progress();
        tl.progress(0, true);
        populateWidths();
        deep && populateTimeline();
        populateOffsets();
        deep && tl.draggable && tl.paused() ? tl.time(times[curIndex], true) : tl.progress(progress, true);
      },
      onResize = () => refresh(!(tl.draggable && tl.draggable.isDragging)),
      proxy;
    gsap.set(items, {x: 0});
    populateWidths();
    populateTimeline();
    populateOffsets();
    window.addEventListener("resize", onResize);
    function toIndex(index, vars) {
      vars = vars || {};
      (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
      let newIndex = gsap.utils.wrap(0, length, index),
        time = times[newIndex];
      if (time > tl.time() !== index > curIndex && index !== curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
        time += tl.duration() * (index > curIndex ? 1 : -1);
      }
      if (time < 0 || time > tl.duration()) {
        vars.modifiers = {time: timeWrap};
      }
      curIndex = newIndex;
      vars.overwrite = true;
      gsap.killTweensOf(proxy);    
      return vars.duration === 0 ? tl.time(timeWrap(time)) : tl.tweenTo(time, vars);
    }
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.closestIndex = setCurrent => {
      let index = getClosest(times, tl.time(), tl.duration());
      if (setCurrent) {
        curIndex = index;
        indexIsDirty = false;
      }
      return index;
    };
    tl.current = () => indexIsDirty ? tl.closestIndex(true) : curIndex;
    tl.next = vars => toIndex(tl.current()+1, vars);
    tl.previous = vars => toIndex(tl.current()-1, vars);
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
      tl.vars.onReverseComplete();
      tl.reverse();
    }
    if (config.draggable && typeof(Draggable) === "function") {
      proxy = document.createElement("div")
      let wrap = gsap.utils.wrap(0, 1),
        ratio, startProgress, draggable, dragSnap, lastSnap, wasPlaying,
        align = () => tl.progress(wrap(startProgress + (draggable.startX - draggable.x) * ratio)),
        syncIndex = () => tl.closestIndex(true);
      typeof(InertiaPlugin) === "undefined" && console.warn("InertiaPlugin required for momentum-based scrolling and snapping. https://greensock.com/club");
      draggable = Draggable.create(proxy, {
        trigger: items[0].parentNode,
        type: "x",
        onPressInit() {
          let x = this.x;
          gsap.killTweensOf(tl);
          wasPlaying = !tl.paused();
          tl.pause();
          startProgress = tl.progress();
          refresh();
          ratio = 1 / totalWidth;
          gsap.set(proxy, {x: startProgress / -ratio});
          // fix bug that existed prior to version 3.14.0 that could cause the inertia to jump due to setting the new x position.
          if (+InertiaPlugin.version.split(".")[1] < 14) {
            let tracker = InertiaPlugin.getByTarget(proxy),
                pt = tracker && tracker._props.x;
            pt && (pt.v1 = pt.v2 = startProgress / -ratio); // effectively resets the velocity (only necessary in old versions, before 3.14.0)
          }
        },
        onDrag: align,
        onThrowUpdate: align,
        overshootTolerance: 0,
        inertia: true,
        snap(value) {
          let time = -(value * ratio) * tl.duration(),
            wrappedTime = timeWrap(time),
            snapTime = times[getClosest(times, wrappedTime, tl.duration())],
            dif = snapTime - wrappedTime;
          Math.abs(dif) > tl.duration() / 2 && (dif += dif < 0 ? tl.duration() : -tl.duration());
          lastSnap = (time + dif) / tl.duration() / -ratio;
          return lastSnap;
        },
        onRelease() {
          syncIndex();
          draggable.isThrowing && (indexIsDirty = true);
        },
        onThrowComplete: () => {
          syncIndex();
          wasPlaying && tl.play();
        }
      })[0];
      tl.draggable = draggable;
    }
    tl.closestIndex(true);
    lastIndex = curIndex;
    onChange && onChange(items[curIndex], curIndex);
    timeline = tl;
    return () => window.removeEventListener("resize", onResize); // cleanup
  });
  return timeline;
}






document.querySelectorAll('.marquee').forEach(marquee => {
  const track = marquee.querySelector('.marquee__track');
  const item = track?.children[0];

  if (!track || !item) return;

  const marqueeWidth = marquee.offsetWidth;
  if (!marqueeWidth) return;

  const baseSpeed = parseFloat(marquee.dataset.speed);
  const speed = isNaN(baseSpeed) ? 1 : baseSpeed;

  const isRTL = marquee.dataset.direction === 'ltr';

  const minWidth = marqueeWidth * 2;

  let safety = 0;
  while (track.scrollWidth < minWidth && safety < 20) {
    track.appendChild(item.cloneNode(true));
    safety++;
  }

  horizontalLoop(track.children, {
    repeat: -1,
    speed: speed,          // siempre positivo
    reversed: isRTL        // aquí va la dirección ✅
  });
});





document.querySelectorAll('.section-promo-carousel').forEach(section => {
  const track = section.querySelector('.promo-carousel__track');
  const items = track?.children;

  if (!track || !items.length) return;

  const wrapper = section.querySelector('.promo-carousel__track-wrapper');
  if (!wrapper.offsetWidth) return;

  // 🔁 Clonar solo para asegurar loop limpio
  let safety = 0;
  while (track.scrollWidth < wrapper.offsetWidth * 2 && safety < 5) {
    [...items].forEach(item => {
      track.appendChild(item.cloneNode(true));
    });
    safety++;
  }

  // 🧠 SLIDER: timeline pausado
  const loop = horizontalLoop(track.children, {
    paused: true,
    speed: 1 // irrelevante mientras esté pausado
  });

  // 🎛 Flechas
  const prev = section.querySelector('.promo-carousel__arrow--prev');
  const next = section.querySelector('.promo-carousel__arrow--next');

  prev?.addEventListener('click', () => {
    loop.previous({
      duration: 0.6,
      ease: 'power2.inOut'
    });
  });

  next?.addEventListener('click', () => {
    loop.next({
      duration: 0.6,
      ease: 'power2.inOut'
    });
  });

  // ▶️ AUTOPLAY OPCIONAL (slider, no marquesina)
  let autoplayDelay = 4000; // ms
  let autoplay = setInterval(() => {
    loop.next({
      duration: 0.6,
      ease: 'power2.inOut'
    });
  }, autoplayDelay);

  // ⏸ Pausa en hover (UX decente)
  section.addEventListener('mouseenter', () => {
    clearInterval(autoplay);
  });

  section.addEventListener('mouseleave', () => {
    autoplay = setInterval(() => {
      loop.next({
        duration: 0.6,
        ease: 'power2.inOut'
      });
    }, autoplayDelay);
  });
});





gsap.registerPlugin(ScrollTrigger, SplitText);

const ROT_MIN = -12;
const ROT_MAX = 12;

const ANIM_CONFIG = {
  words: {
    from: {
      autoAlpha: 0,
      scale: 0.5,
      //y: '150%',
      rotation: () => gsap.utils.random(ROT_MIN, ROT_MAX),
      transformOrigin: '50% 50%'
    },
    to: {
      autoAlpha: 1,
      scale: 1,
      //y: '0%',
      rotation: 0,
      duration: 0.6,
      ease: 'power3.out',
      stagger: 0.03
    }
  },
  lines: {
    from: {
      autoAlpha: 0,
      y: '80%'
    },
    to: {
      autoAlpha: 1,
      y: '0%',
      duration: 0.5,
      ease: 'power3.out',
      stagger: 0.08
    }
  }
};

const initSplitTextReveal = () => {
  const elements = document.querySelectorAll('.reveal-text');

  elements.forEach((el) => {
    const splitType = el.classList.contains('lines') ? 'lines' : 'words';

    const split = new SplitText(el, {
      type: splitType
    });

    const targets = split[splitType];
    const config = ANIM_CONFIG[splitType];

    // Estado inicial
    gsap.set(targets, config.from);

    // Animación
    gsap.to(targets, {
      ...config.to,
      scrollTrigger: {
        trigger: el,
        start: 'top 90%',
        once: true
      }
    });
  });
};

initSplitTextReveal();






const animateBoxes = () => {
  const boxes = document.querySelectorAll('.enters');

  boxes.forEach((box) => {
    gsap.fromTo(
      box,
      {
        scale: .8,
        y: 100,
        autoAlpha: 0,
      },
      {
        scale: 1,
        y: 0,
        autoAlpha: 1,
        ease: 'power3.out',
        duration: .9,
        scrollTrigger: {
          trigger: box,
          start: 'top 90%',
          // toggleActions: 'play none none none',
          once: true
        }
      }
    );
  });
};

animateBoxes();



const animateCloudPaths = () => {
  const paths = document.querySelectorAll('.clouds svg path');

  paths.forEach((path) => {
    gsap.set(path, {
        transformOrigin: '50% 50%',
        transformBox: 'fill-box'
    });
    gsap.fromTo(
      path,
      {
        scale: .8,
        autoAlpha: 0,
      },
      {
        scale: 1,
        autoAlpha: 1,
        ease: 'power1.out',
        duration: .3,
        scrollTrigger: {
          trigger: path,
          start: 'top 90%',
          // toggleActions: 'play none none none',
          once: true
        }
      }
    );
  });
};

animateCloudPaths();



const animateAsterisk = () => {
  const paths = document.querySelectorAll('.asterisk');

  paths.forEach((path) => {
    gsap.fromTo(
      path,
      {
        scale: 0,
        rotation: 25,
      },
      {
        scale: 1,
        rotation: 0,
        ease: 'power4.out',
        duration: 1,
        scrollTrigger: {
          scrub: true,
          trigger: path,
          start: 'top bottom',
          // toggleActions: 'play none none none',
          once: true
        }
      }
    );
  });
};

animateAsterisk();









if(document.querySelectorAll('#intro-scroll')) {

const duration = 150;

function drawImageContain(context, image, targetX, targetY, targetWidth, targetHeight) {
			const imageAspectRatio = image.width / image.height;
			const targetAspectRatio = targetWidth / targetHeight;

			let drawWidth = targetWidth;
			let drawHeight = targetHeight;
			let drawX = targetX;
			let drawY = targetY;

			if (imageAspectRatio > targetAspectRatio) {
				// Image is wider than the target area, scale by width
				drawHeight = targetWidth / imageAspectRatio;
				drawY = targetY + (targetHeight - drawHeight) / 2; // Center vertically
			} else {
				// Image is taller than the target area, scale by height
				drawWidth = targetHeight * imageAspectRatio;
				drawX = targetX + (targetWidth - drawWidth) / 2; // Center horizontally
			}

			context.drawImage(image, drawX, drawY, drawWidth, drawHeight);
		}

		const canvas = document.getElementById("hero-lightpass");
		const context = canvas.getContext("2d");
		const dpr = window.devicePixelRatio || 1; // Default to 1 if not available

		const rect = canvas.getBoundingClientRect();
canvas.width  = rect.width  * dpr;
canvas.height = rect.height * dpr;
context.setTransform(dpr, 0, 0, dpr, 0, 0);

		const airpods = {
			frame: 0
		};
		let maxWidth = 0,
			maxHeight = 0,
			maxWidthRatio = 1,
			maxHeightRatio = 1,
			targetWidth = 0,
			targetHeight = 0;

      const armadoIndex = Math.floor(Math.random() * 4) + 1;
const imagesSrc = window.ARMADO_SETS[armadoIndex];

      const images = [];
		const frameCount = 6;

imagesSrc.forEach(src => {
  const img = new Image();
  img.src = src;
  images.push(img);
});

		gsap.to(airpods, {
			frame: frameCount - 1,
			snap: "frame",
			ease: "none",
			scrollTrigger: {
				trigger: ".canvas-container",
				start: "top top",
				end: "+=" + window.innerHeight * Math.ceil(frameCount / 3),
				pin: true,
				scrub: 0.5
			},
			onUpdate: render // use animation onUpdate instead of scrollTrigger's onUpdate
		});

		images[0].onload = render;

    function isPortrait() {
  return window.innerHeight > window.innerWidth;
}

function render() {
  context.clearRect(0, 0, canvas.width, canvas.height);

  const img = images[airpods.frame];
  if (!img) return;

  const cw = canvas.width / dpr;
  const ch = canvas.height / dpr;

  let targetWidth  = cw * 0.9;
  let targetHeight = ch * 0.9;

  if (window.innerHeight > window.innerWidth) {
    targetWidth  = cw * 0.83;
    targetHeight = ch * 0.83;
  }

  const targetX = (cw - targetWidth) / 2;
  const targetY = (ch - targetHeight) / 2;

  drawImageContain(
    context,
    img,
    targetX,
    targetY,
    targetWidth,
    targetHeight
  );
}

/*
    window.addEventListener('resize', () => {
  const rect = canvas.getBoundingClientRect();
  canvas.width = rect.width * dpr;
  canvas.height = rect.height * dpr;
  render();
});
*/



		jQuery(window).on('load', function() {
			if (jQuery('.parallax_holder').length) {
				const parallaxes = gsap.utils.toArray('.parallax_holder');
				parallaxes.forEach((parallaxHolder) => {
					const parallax = parallaxHolder.querySelector('.parallax');
					gsap.to(parallax, {
						y: 100 * jQuery(parallax).data('parallax-speed'),
						scrollTrigger: {
							scrub: true,
							ease: 'none',
							start: 'top bottom',
							end: 'bottom top',
							trigger: parallaxHolder,
						},
					});
				});
			}

			if (jQuery('.split-text').length) {
				console.log(duration);
				document.fonts.ready.then(() => {
					gsap.registerPlugin(SplitText);

					let ctxLines;
					ctxLines = gsap.context(() => {
						let splitLines = gsap.utils.toArray('.split-lines');
						splitLines.forEach((item, index) => {
							console.log(item.dataset.delay);
							let splitLines = SplitText.create(item, {
								type: 'lines',
								mask: 'lines',
								linesClass: 'line',
								autoSplit: true,
								onSplit(self) {
									return gsap.from(self.lines, {
										ease: 'power4.out',
										duration: duration * 0.005,
										delay: item.dataset.delay ?
											(duration * item.dataset.delay) / 1000 : (duration * 1) / 1000,
										y: '120%',
										stagger: 0.05,
										scrollTrigger: {
											trigger: item,
											start: 'top bottom',
											toggleActions: 'play none none reset',
										},
										// onComplete: () => self.revert(), // revert the element to its original (unsplit) state
									});
								},
							});
						});
					});

					let ctxWords;
					ctxWords = gsap.context(() => {
						let splitWords = gsap.utils.toArray('.split-words');
						splitWords.forEach((item, index) => {
							let splitWords = SplitText.create(item, {
								type: 'words',
								// mask: 'words',
								wordsClass: 'word',
								autoSplit: true,
								onSplit(self) {
									return gsap.from(self.words, {
										ease: 'power4.out',
										duration: duration * 0.005,
										delay: item.dataset.delay ?
											(duration * item.dataset.delay) / 1000 : (duration * 1) / 1000,
										rotate: '-15deg',
										opacity: 0,
										scale: 0,
										stagger: 0.05,
										scrollTrigger: {
											trigger: item,
											start: 'top bottom',
											toggleActions: 'play none none reset',
										},
										// onComplete: () => self.revert(), // revert the element to its original (unsplit) state
									});
								},
							});
						});
					});
				});
			}
			setTimeout(() => {
				jQuery('#intro-scroll .parallax img').each(function() {
					jQuery(this).css('transform', 'scale(1) rotate(0deg)');
				});
			}, 500);
			setTimeout(() => {
				jQuery('#intro-scroll .canvas-container').each(function() {
					jQuery(this).css('opacity', 1);
				});
			}, 1000);
		});

  }